import { globalVariables } from "helper/globalVariables";
import SearchBar from "./Components/search";
import { Button } from "./Components/button";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { useEffect, useMemo, useRef, useState } from "react";
import { globalClasses } from "helper/globalClasses";
import { debounce } from "lodash";
import { Upload } from "../Upload";
import { externalLink } from "helper/icons";
import { useUploadFileMutation } from "redux/features/trailResults/uploadFileApiSlice";
import { PopUpMessages } from "shared/Components/popUpMessages";
import Modal from "shared/Components/modal";
import { useMediaQuery } from "react-responsive";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import { MobilePagination } from "shared/Components/mobilePagination";
import Loader from "shared/Components/loader";
import { TrialResultCard } from "./Components/TrialResultCard";
import { ResultCard } from "./Components/ResultCard";
import { useNavigate } from "react-router-dom";
import { UploadModal } from "../Upload/UploadModal";
import { TrialCalendarQuery } from "redux/features/trialCalendar/trialCalendarGql";
import { EditSitResultCard } from "../EditSit/Components/EditSitResultCard";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import PageInfo from "shared/Components/pageInfo";

export const UploadTrialResults = () => {
  const isTabletMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const [fileLoading, setFileLoading] = useState();
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);
  const [uploadFileMutation] = useUploadFileMutation();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const modalRef = useRef();
  const tableModalRef = useRef();

  const isMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const { tableDataCls, paginatedDataCls } = globalClasses;
  const headData = [
    globalVariables.trialResultDate,
    globalVariables.trialName,
    globalVariables.city,
    globalVariables.state,
    globalVariables.zipCode,
    // globalVariables.trialResultLocation,
    globalVariables.trailStatus,
    globalVariables.trialResultViewResult,
  ];

  const [getData, { loading, error, data }] = useLazyQuery(TrialCalendarQuery);
  const resultData = data?.getAllTrialCalendar;
  const filteredTableData = useMemo(() => resultData?.data || [], [resultData]);

  const showResults = (id) => {
    navigate(`${id}`);
  };

  const renderTableBody = () => {
    return filteredTableData.map((data, index) => (
      <tr key={data.name}>
        <td className={paginatedDataCls(index)}>
          {moment.utc(data?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
        </td>
        <td className={paginatedDataCls(index)}>{data?.trial?.trialName}</td>
        {/* <td className={paginatedDataCls(index)}>
          {data.trial?.trialLocationAddress}
        </td> */}
        <td className={paginatedDataCls(index)}>{data.trial?.city}</td>
        <td className={paginatedDataCls(index)}>{data.trial?.state}</td>
        <td className={paginatedDataCls(index)}>{data.trial?.zip}</td>

        <td className={paginatedDataCls(index)}>
          {data?.trial?.approvalStatus}
        </td>

        <td className={`${paginatedDataCls(index)} ml-2`}>
          <div
            className="flex flex-row cursor-pointer justify-center"
            onClick={() => showResults(data.id)}
          >
            <img src={externalLink} alt="link" className="ml-4" />
          </div>
        </td>
      </tr>
    ));
  };

  const [openUploadModal, setOpenUploadModal] = useState(false);

  const Show = (status) => {
    setIsShow(status);
    setOpenUploadModal(status);
  };

  const handleUploadModalFromTable = (modelFlag) => {
    setOpenUploadModal(modelFlag);
    // setIsShow(modelFlag);
  };
  const formatUploadError = (errorPayload) => {
    const data = errorPayload?.data || {};
    const parts = [];
    if (data.message) parts.push(data.message);
    if (data.summary && data.summary !== data.message) parts.push(data.summary);
    if (Array.isArray(data.errors) && data.errors.length) {
      parts.push("");
      parts.push(...data.errors);
    }
    return parts.length ? parts.join("\n") : "Upload failed. Please try again.";
  };

  const handleApiCall = async ({ file, id }) => {
    try {
      if (file) {
        setFileLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("trialCalendarId", id);
        const result = await uploadFileMutation(formData);

        if (result?.error) {
          setFileLoading(false);
          modalRef.current.openModal();
          setApiData({
            ...apiData,
            title: globalVariables.error,
            desc: formatUploadError(result?.error),
            type: "pending",
          });
          return null;
        }
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: "Success!",
          desc: result?.data?.message,
          type: "success",
        });
        setFileLoading(false);
        return result;
      }
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: "Upload the file",
        type: "pending",
      });
      return {};
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error.message,
        type: "pending",
      });
      setFileLoading(false);
      return null;
    }
  };

  const showTable = async (file, id) => {
    const data = await handleApiCall({ file, id });
    if (data) {
      setIsShow(false);
      setOpenUploadModal(false);
    }
  };

  const openModal = (trialIndex) => {
    setSelectedTrialIndex(trialIndex);
    tableModalRef.current.openModal();
  };

  const handlePaginationData = ({ page = 1, size = 10, search = "" }) => {
    getData({
      variables: {
        pageNumber: page,
        pageSize: size,
        search,
        role: "Host",
        approvalStatus: "Approve",
        excludeShared: true,  // Only show trials created by this user
      },
    });
  };

  const onSearch = (event) => {
    const value = event?.target?.value;
    if (value) {
      setSearch(value);
      handlePaginationData({
        search: value,
      });
    } else {
      handlePaginationData({});
    }
  };

  const debouncedSearch = debounce(onSearch, 1000);

  useEffect(() => {
    handlePaginationData({});
  }, []);

  useEffect(() => {
    if (!loading && filteredTableData?.length <= 0 && !search) {
      Show(true);
    } else {
      Show(false);
    }
  }, [filteredTableData, loading, search]);

  return (
    <>
      <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
        <PageInfo title={globalVariables.uploadTrialResults}>
          <Button
            label={globalVariables.uploadTrialResults}
            disabled={false}
            onClick={() => handleUploadModalFromTable(true)}
          />
        </PageInfo>
        {isShow ? (
          <Upload
            showTable={showTable}
            loading={fileLoading}
            // notCloseModal={true}
            // modalOpen={openUploadModal}
            // openFromTable={openUploadModal}
          />
        ) : (
          <div>
          <div className="flex flex-col gap-4 visible min-[480px]:hidden mb-4">
          <span className="text-xl font-semibold text-gray-900 ">
            Search for trials
          </span>
            <SearchBar
              width={"w-80 sm:w-96 "}
              onChange={debouncedSearch}
              placeholder={"Fimmere Village, Novice"}
            />
            </div>
            {!isMobile ? (
              <TableWithPagination
                headerComponent={
                  <SearchBar
                    onChange={debouncedSearch}
                    placeholder={"Fimmere Village, Novice"}
                  />
                }
                headData={headData}
                tableBody={renderTableBody()}
                itemsPerPage={10}
                tableHeight={`${isTabletMobile ? "h-[80vh]" : "h-[530px]"}`}
                totalPage={resultData?.totalPages}
                handlePageChange={(page) => handlePaginationData({ page })}
                loading={loading}
                error={error}
              />
            ) : (
              <>
                {!loading && !error ? (
                  <>
                    {filteredTableData.length > 0 ? (
                      <div className="pb-[55px]">
                        {filteredTableData?.map((data, index) => {
                          return (
                            <div key={data.id} className="result-card-box">
                              <ResultCard
                                {...data}
                                onViewResult={() => openModal(index)}
                              />
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="flex justify-center mt-[40%]">
                        <span className="font-semibold text-xl text-gray-900">
                          No Records
                        </span>
                      </div>
                    )}
                    {resultData?.totalPages > 1 ? (
                      <MobilePagination
                        currentPage={resultData?.pageNumber}
                        totalPages={resultData?.totalPages}
                        handlePageChange={(page) =>
                          handlePaginationData({ page })
                        }
                      />
                    ) : (
                      ""
                    )}
                  </>
                ) : loading ? (
                  <Loader stroke="text-gradient-500" />
                ) : (
                  <span>{error?.message}</span>
                )}
                <Modal ref={tableModalRef}>
                  {selectedTrialIndex !== null && (
                    <TrialResultCard
                      icon={true}
                      name={
                        filteredTableData[selectedTrialIndex].host?.hostName
                      }
                      date={moment(
                        filteredTableData[selectedTrialIndex].trial?.trialDate
                      ).format(DEFAULT_DATE_FORMAT)}
                      closeDate={moment(
                        filteredTableData[selectedTrialIndex].trial?.closeDate
                      ).format(DEFAULT_DATE_FORMAT)}
                      location={
                        filteredTableData[selectedTrialIndex]?.trial
                          ?.trialLocationName
                      }
                      level={[...new Set(filteredTableData[selectedTrialIndex]?.search
                        ?.map((search) => search?.level))].join(", ")}
                      status={
                        filteredTableData[selectedTrialIndex].trial?.status
                      }
                      onDetail={() => {
                        showResults(filteredTableData[selectedTrialIndex].id);
                      }}
                    />
                    // <EditSitResultCard
                    //   name={
                    //     filteredTableData[selectedTrialIndex].host?.hostName
                    //   }
                    //   date={moment(
                    //     filteredTableData[selectedTrialIndex].trial?.trialDate
                    //   ).format(DEFAULT_DATE_FORMAT)}
                    //   closeDate={moment(
                    //     filteredTableData[selectedTrialIndex].trial?.closeDate
                    //   ).format(DEFAULT_DATE_FORMAT)}
                    //   location={
                    //     filteredTableData[selectedTrialIndex]?.trial
                    //       ?.trialLocationName
                    //   }
                    //   level={filteredTableData[selectedTrialIndex]?.search
                    //     ?.map((search) => search?.level)
                    //     ?.join(", ")}
                    //   status={
                    //     filteredTableData[selectedTrialIndex].trial?.status
                    //   }
                    //   onDetail={() =>
                    //     showResults(filteredTableData[selectedTrialIndex].id)
                    //   }
                    // />
                  )}
                </Modal>
              </>
            )}
            <UploadModal
              showTable={showTable}
              modalOpen={openUploadModal}
              // notCloseModal={notCloseModal}
              loading={fileLoading}
              onClose={() => handleUploadModalFromTable(false)}
            />
          </div>
        )}
      </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
      />
    </>
  );
};
